import certsyProfileImg from "@skv/assets/gfx/certsy-profile.svg";
import { AspectRatio, SvgSprite } from ".";

interface CertsyCtaProps {
  certsyHirerLandingUrl: string;
}

export const CertsyCta = ({
  certsyHirerLandingUrl,
}: CertsyCtaProps): JSX.Element => {
  return (
    <div
      className="card text-center text-sm-left overflow-hidden mb-4 p-3"
      css={`
        background: #d0d4e5;
      `}
    >
      <div className="d-flex justify-content-center justify-content-sm-start mb-3">
        <AspectRatio width={120} height={12} style={{ width: "120px" }}>
          <SvgSprite id="logos:certsy-logo" />
        </AspectRatio>
      </div>

      <div
        css={`
          width: 100%;
          @media (min-width: ${(p): string => p.theme.smBreakpoint}) {
            width: 70%;
          }
          @media (min-width: ${(p): string => p.theme.mdBreakpoint}) {
            width: 50%;
          }
        `}
      >
        <h2 className="h5 text-secondary">Hassle-free compliance checks</h2>
        <p className="mx-auto mx-sm-0 mb-2">
          Get early access to a simple way to conduct compliance checks and
          credential management.
        </p>
        <a href={certsyHirerLandingUrl} className="btn btn-danger mb-3 mb-sm-0">
          Learn more
        </a>
      </div>
      <div
        className="text-right"
        css={`
          margin: 0 auto -20%;

          @media (min-width: ${(p): string => p.theme.smBreakpoint}) {
            margin: 0;
            max-width: 50%;
            position: absolute;
            bottom: -15%;
            right: -5%;
          }
        `}
      >
        <img
          src={certsyProfileImg}
          alt="people at desk"
          className="img-fluid"
          width={220}
          height={170}
        />
      </div>
    </div>
  );
};
